import styled from "@emotion/styled";
import { toastTheme } from "./toastTheme";
export const ToastActionStyled = styled("button")`
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    height: 32px;
    min-width: 32px;
    padding: ${_ref => {
  let {
    themeMode
  } = _ref;
  return toastTheme.actionButton.padding(themeMode);
}};
    border: none;
    border-radius: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return toastTheme.actionButton.borderRadius(themeMode);
}}};
    cursor: pointer;
    font-weight: 600;
    color: currentColor;

    display: inline-flex;
    align-items: center;
    justify-content: space-around;
    white-space: nowrap;

    background-color: transparent;

    &:hover {
        background-color: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return toastTheme.actionButton.backgroundColor.hover(themeMode);
}};
    }

    &:active {
        background-color: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return toastTheme.actionButton.backgroundColor.pressed(themeMode);
}};
    }

`;
//# sourceMappingURL=ToastActionStyled.js.map